import React, { useState } from "react";
import { defer, useLoaderData } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { alpha } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import { format } from 'date-fns';

import { Card /* CardHeader */ } from "src/components/commons/Card";
import { getActiveCampaignsWithMatches, getAll as getAllCampaigns } from "src/api/campaigns";
import { Async } from "src/components/commons/Async";
import { ONBOARDING_STEPS, ROLES } from "src/helpers/constants";
import { getActiveOpportunitiesWithMatches, getAll as getAllOpportunities } from "src/api/opportunities";
import { getActiveVendorServicesWithMatches, getAll as getAllVendorServices } from "src/api/vendorServices";
import { useDispatch, useSelector } from "react-redux";
import { updateUserOnboarding } from "src/store/slices/auth";
import FounderOnboardingWizard from "src/components/dashboard/FounderOnboarding";
import FunderOnboardingWizard from "src/components/dashboard/FunderOnboarding";
import VendorOnboardingWizard from "src/components/dashboard/VendorOnboarding";
import { FounderDashboard } from "src/components/campaigns/Dashboard";
import { FunderDashboard } from "src/components/opportunities/Dashboard";
import { VendorDashboard } from "src/components/vendorServices/Dashboard";
import { Information } from "src/components/dashboard/Information";
import { EmptyState } from "src/components/dashboard/EmptyState";
import { TenantAdminDashboard } from "src/components/opportunities/TenantAdminDashboard";
import KeywordInput from "src/components/commons/Inputs/KeywordInput";
import { wrap } from "@sentry/react";

// import RecentTickets from "./RecentTickets";
// import TasksList from "./TasksList";
// import WelcomeSummary from "./WelcomeSummary";
// import RecentActivities from "./RecentActivities";
// import TicketsStatus from "./TicketsStatus";
// import ProjectCounterCard from "./ProjectCounterCard";
// import OpportunitiesCounterCard from "./OpportunitiesCounterCard";
// import TasksCounterCard from "./TasksCounterCard";
// import TeamsCounterCard from "./TeamsCounterCard";
// import TeamMembersList from "./TeamMembersList";
// import TeamsList from "./TeamsList";
// import { getDashboardData } from "src/redux/actions/Dashboard";

const useStyles = makeStyles((theme) => ({
	emptyState: {
		padding: "5rem",
		color: alpha(theme.palette.common.black, 0.5),
	},
	ulreset: {
		listStyle: "none",
	},
	dashboardContainer: {
		backgroundColor: 'white',
		padding: '2rem',
		marginLeft: '-89px',
		width: 'calc(100vw - 217px)',
		top: 0,
		right: 0,
		marginBottom: '10px',
		overflowY: 'auto',

		// For larger screens (desktops)
		['@media (min-width:1024px)']: {
			padding: '2rem',
			marginLeft: '-89px',
			width: 'calc(100vw - 217px)',
		  },
		
		  // For tablets
		  ['@media (max-width:1023px)']: {
			marginLeft: 0,
			width: '100vw',
			padding: '1.25rem',
		  },
		
		  // For mobile
		  ['@media (max-width:640px)']: {
			padding: '1rem',
			flexDirection: 'row',
			flexWrap: 'wrap',
			alignItems: 'center',
			gap: 0,
		  },
	},
	datePill: {
		// backgroundColor: theme.palette.primary.main,
		backgroundColor: '#3096F5',
		color: 'white',
		padding: '0.5rem 1rem',
		borderRadius: '9999px',
		display: 'inline-flex',
		alignItems: 'center',
		gap: '0.5rem',

		['@media (max-width:640px)']: {
			padding: '1rem',
			flexWrap: 'wrap',
		  },
	},
	row: {
		display: 'flex',
		alignItems: 'center',
		gap: '10px', /* optional space between them */
	  },
	  
}));
export function Dashboard() {
	const classes = useStyles();
	const { authUser, currentRole } = useSelector(({ auth }) => auth);
	const dispatch = useDispatch();
	const { data, entity } = useLoaderData();
	const [isNonAccreditedInvestor] = useState(() => {
		return !!authUser.profile?.positions?.find((i) => i.toLowerCase().includes("non-accredited"));
	});
	const [showInfoModal, setShowInfoModal] = useState(
		() => authUser.onboarding[currentRole]?.completedStep === ONBOARDING_STEPS.SIGNUP
	);
	const [GrantModalopen, GrantModalsetOpen] = useState(false);

	// Modal open/close handlers
	const handleOpen = () => GrantModalsetOpen(true);
	const handleClose = () => GrantModalsetOpen(false);
	const [results, setResults] = useState(null);

	const handleResults = (data) => {
		setResults(data);
	};
	// const [showOpportunityModal, setShowOpportunityModal] = useState(false);
	// const selectedMatchedOpportunity = useRef(null);

	async function completeOnboarding() {
		const completedStep =
			currentRole === ROLES.FOUNDER
				? ONBOARDING_STEPS.TEAM
				: currentRole === ROLES.FUNDER
				? ONBOARDING_STEPS.ORGANIZATION
				: 0;
		return dispatch(updateUserOnboarding({ isCompleted: true, completedStep }));
	}

	if (isNonAccreditedInvestor) {
		return (
			<Card>
				<div className="min-h-[320px] p-4 text-center text-xl text-gray-500 flex justify-center items-center">
					You are all caught up. We will let you know once we have relevant opportunities.
				</div>
			</Card>
		);
	}

	if (authUser.onboarding && !authUser.onboarding[currentRole]?.isCompleted) {
		return (
			<Card>
				{showInfoModal && (
					<Modal
						open={showInfoModal}
						// maxWidth="xs"
						onClose={() => setShowInfoModal(false)}
						aria-labelledby="info-modal-title"
						aria-describedby="info-modal-description"
					>
						<Information onClose={() => setShowInfoModal(false)} />
					</Modal>
				)}
				{currentRole === ROLES.FOUNDER ? (
					<FounderOnboardingWizard onCompleteOnboarding={completeOnboarding} />
				) : currentRole === ROLES.FUNDER ? (
					<FunderOnboardingWizard onCompleteOnboarding={completeOnboarding} />
				) : (
					<VendorOnboardingWizard onCompleteOnboarding={completeOnboarding} />
				)}
			</Card>
		);
	}

	return (
		<Box component={"main"} id={`dashboard-${entity}`}>
			<div className={`${classes.dashboardContainer} border-t border-l border-slate-200`}>
				<div className="flex justify-between items-center mb-6">
					<Typography component={"h1"} variant={"body1"} color="textSecondary">
						Dashboard
					</Typography>
					<div className={classes.row}>
					<div className={classes.datePill}>
						<Typography variant="body2">
							{format(new Date(), 'EEEE, MMMM d, yyyy')}
						</Typography>
					</div>
					{authUser.roles.includes(ROLES.SUPERADMIN) && (
					<div className={classes.datePill} onClick={handleOpen} style={{ cursor: 'pointer' }}>
						<Typography variant="body2">
							Grants For You
						</Typography>
					</div>
					)}
					</div>
				</div>
			</div>
				{authUser.roles.includes(ROLES.TENANT_ADMIN) ? (
					<TenantAdminDashboard />
				) : (
					<Async error={"Could not load the dashboard"} promise={data}>
						{({ activeEntityData, allEntityData }) => {
							if (allEntityData.length <= 0) {
								return <EmptyState classes={classes} entity={entity} />;
							}
							if (currentRole === ROLES.FOUNDER) {
								return <FounderDashboard activeCampaignsWithMatches={activeEntityData} allCampaigns={allEntityData} />;
							} else if (currentRole === ROLES.FUNDER) {
								return (
									<FunderDashboard activeOpportunitiesWithMatches={activeEntityData} allOpportunities={allEntityData} />
								);
							} else if (currentRole === ROLES.VENDOR) {
								return (
									<VendorDashboard activeVendorServicesWithMatches={activeEntityData} allVendorServices={allEntityData} />
								);
							} else {
								return <div>Unimplemented</div>;
							}
						}}
					</Async>
				)}
			{/* Modal */}
			<Modal open={GrantModalopen} onClose={handleClose}>
				<Box
				sx={{
					position: 'absolute',
					top: '50%',
					left: '50%',
					transform: 'translate(-50%, -50%)',
					bgcolor: 'background.paper',
					borderRadius: 2,
					boxShadow: 24,
					p: 0, // move padding inside scrollable area
					width: '90%',
					maxWidth: 600,
					height: '80vh', // make modal tall enough
					display: 'flex',
					flexDirection: 'column',
				}}
				>
				{/* Header stays fixed */}
				<div className="p-4 border-b border-gray-200">
					<KeywordInput onResults={handleResults}/>
				</div>
				{/* Scrollable content area */}
				<div className="flex-1 overflow-y-auto p-4">
				<Typography variant="h6" gutterBottom className="mt-6">
					Available Grants
				</Typography>
				{/* Render results as cards */}
				{Array.isArray(results) && results.length > 0 ? (
					<div className="grid grid-cols-1 gap-4 mt-3">
						{results.map((grant) => (
						<div
							key={grant.id}
							className="border border-gray-200 rounded-xl p-4 shadow-sm hover:shadow-md transition duration-200"
						>
							<Typography variant="subtitle1" className="font-semibold text-gray-800 mb-1">
							{grant.title}
							</Typography>

							<Typography variant="body2" color="textSecondary" className="mb-2">
							<span className="font-medium">Agency:</span> {grant.agency}
							</Typography>

							<div className="flex flex-wrap text-sm text-gray-600 mb-2 space-x-3">
							<span>
								<strong>Open:</strong> {grant.openDate || "N/A"}
							</span>
							<span>
								<strong>Close:</strong> {grant.closeDate || "N/A"}
							</span>
							<span>
								<strong>Status:</strong> {grant.oppStatus}
							</span>
							</div>

							{grant.cfdaList?.length > 0 && (
							<Typography variant="body2" className="text-gray-700 mb-2">
								<strong>CFDA:</strong> {grant.cfdaList.join(", ")}
							</Typography>
							)}

							<a
							href={grant.detailUrl}
							target="_blank"
							rel="noopener noreferrer"
							className="inline-block mt-2 text-blue-600 hover:underline font-medium"
							>
							View Details →
							</a>
						</div>
						))}
					</div>
					) : results && !Array.isArray(results) ? (
					<Typography variant="body2" color="textSecondary">
						{JSON.stringify(results, null, 2)}
					</Typography>
					) : (
					<Typography variant="body2" color="textSecondary" className="mt-2">
						No grants found yet — try entering some keywords.
					</Typography>
				)}
				</div>
				</Box>
			</Modal>
		</Box>
	);
}

export function dashboardLoader({ currentRole }) {
	const promises = [];
	let entity = ROLES.FOUNDER;
	if (currentRole === ROLES.FUNDER) {
		entity = ROLES.FUNDER;
		promises.push(getActiveOpportunitiesWithMatches());
		promises.push(getAllOpportunities());
	} else if (currentRole === ROLES.FOUNDER) {
		entity = ROLES.FOUNDER;
		promises.push(getActiveCampaignsWithMatches());
		promises.push(getAllCampaigns());
	} else if (currentRole === ROLES.VENDOR) {
		entity = ROLES.VENDOR;
		promises.push(getActiveVendorServicesWithMatches());
		promises.push(getAllVendorServices());
	} else {
		throw new Response(`Invalid role ${currentRole}`, { status: 404 });
	}
	const promise = Promise.all(promises).then(([activeEntityData, allEntityData]) => {
		return {
			activeEntityData,
			allEntityData,
		};
	});
	return defer({
		entity,
		data: promise,
	});
}
